import 'react-native-gesture-handler';
import { DarkTheme, DefaultTheme, ThemeProvider } from '@react-navigation/native';
import { useFonts } from 'expo-font';
import { Stack } from 'expo-router';
import * as SplashScreen from 'expo-splash-screen';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useColorScheme } from '@/hooks/useColorScheme';
import { useRouter } from 'expo-router';
import { isLoggedIn } from '@/services/typo3api/auth';
import { removeAllEventListeners, addEventListener } from '@/services/EventService';
import { GestureHandlerRootView } from 'react-native-gesture-handler';

SplashScreen.preventAutoHideAsync();

export default function RootLayout() {
  const colorScheme = useColorScheme();
  const router = useRouter();
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null);
  const [stackName, setStackName] = useState('(tabs)');

  const [fontsLoaded] = useFonts({
    SpaceMono: require('../assets/fonts/SpaceMono-Regular.ttf'),
  });

  useEffect(() => {
    if (fontsLoaded) {
      SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  const checkLogin = async () => {
    const status = await isLoggedIn();
    setLoggedIn(status);
  };
 
  const rerouteLogin = async () => {
    await checkLogin();
    setStackName("(tabs)");
    router.navigate("/(tabs)");
  };  
  const rerouteLogout = async () => {
    await checkLogin();
    setStackName("(auth)");
    router.navigate("/(auth)");
  };

  useEffect(() => {
    const init = async () => {
      addEventListener('LoginEvent', rerouteLogin);
      addEventListener('LogoutEvent', rerouteLogout);

      await checkLogin();
    };
    init();
    return () => {
      removeAllEventListeners('LoginEvent');
      removeAllEventListeners('LogoutEvent');
    };
  }, []);

  if (!fontsLoaded && !loggedIn) {
    return null;
  }

  return (
    <GestureHandlerRootView>
    <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <View style={{ flex: 1 }}>
        {stackName === '(tabs)' ? (
          <Stack>
            <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
            <Stack.Screen name="Modal" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        ) : (
          <Stack>
            <Stack.Screen name="(auth)" options={{ headerShown: false }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        )}
      </View>
    </ThemeProvider>
    </GestureHandlerRootView>
  );
}
